import styled from '@emotion/styled';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AchatEntity } from '../../../entities/achat.entity';
import {
  BondBidAskType,
  BondEntity,
  BondOptionsType,
} from '../../../entities/bond.entity';
import { Layout } from '../../shared/Layout';
import { Preloader } from '../../shared/Preloader';
import { Activity } from '../components/Activity';
import { GraphData } from '../components/GraphData';
import { InstrumentDetail } from '../components/IntrusmentDetail';
import { Monitor } from '../components/Monitor';
import { News } from '../components/News';
import { OrderEntry } from '../components/OrderEntry';
import {
  getAvailableBonds,
  getBondBidAsk,
  getBondMarket,
  getBondOptions,
  getUserOrders,
  getUserTransactions,
} from '../network';

const Container = styled.div`
  display: flex;
  margin-top: 2px;
  height: calc(100vh - 32px);

  > .box1 {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin: 1px;
    height: calc(100vh - 33px);

    > .container11 {
      flex: 1;
      border: 1px solid grey;
      margin-bottom: 3px;
      border-radius: 10px;
    }

    > .container12 {
      flex: 2;
      margin-bottom: 3px;
      display: flex;

      > .container121 {
        flex: 1.25;
        border: 1px solid grey;
        border-radius: 10px;
        margin-right: 3px;
      }

      > .container122 {
        flex: 2;
        border: 1px solid grey;
        border-radius: 10px;
      }
    }

    > .container13 {
      flex: 1;
      border: 1px solid grey;
      border-radius: 10px;
      margin-bottom: 3px;
    }
  }

  > .box2 {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin: 1px;
    height: calc(100vh - 33px);

    > .container21 {
      flex: 3;
      border: 1px solid grey;
      margin-bottom: 3px;
      border-radius: 10px;
    }

    > .container22 {
      flex: 1;
      border: 1px solid grey;
      margin-bottom: 3px;
      border-radius: 10px;
    }
  }
`;

export const Dashboard = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [selectedBond, setSelectedBond] = useState<BondEntity>();
  const [selectedBondforOPE, setSelectedBondForOPE] = useState<BondEntity>();
  const [selectedOperation, setSelectedOperation] = useState('0');
  const connectedUser = useSelector((state: any) => state.userReducer).user;
  const [bonds, setBonds] = useState<BondEntity[]>([]);
  const [bondOptions, setBondOptions] = useState<BondOptionsType>();
  const [orders, setOrders] = useState<AchatEntity[]>([]);
  const [transactions, setTransactions] = useState([]);
  const [marketData, setMarketData] = useState([]);
  const [bondBidAsk, setBondBidAsk] = useState<BondBidAskType>({
    bid: 0,
    ask: 0,
    vendeurMKT: 0,
    acheteurMKT: 0,
  });
  const [detVendeur, setDetVendeur] = useState(''); // alimenté lorsqu'on clique pour la vente d'un titre dans "Portefeuille"

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectedBond) {
      getBondMarket(selectedBond.id).then(({ data }) => {
        setMarketData(data);
      });
      getBondBidAsk(selectedBond.id).then(({ data }) => {
        setBondBidAsk(data);
      });
    }
  }, [selectedBond]);

  const fetchData = async () => {
    await getAvailableBonds(connectedUser.id).then(({ data }) => {
      setBonds(data);
    });
    await getBondOptions().then(({ data }) => {
      setBondOptions(data);
    });
    await getUserOrders(connectedUser.id).then(({ data }) => {
      setOrders(data);
    });
    await getUserTransactions(connectedUser.id).then(({ data }) => {
      setTransactions(data);
    });
    setIsLoading(false);
  };

  const getBondForOperation = (
    b: BondEntity,
    ope: '1' | '2',
    detUrl?: string,
  ) => {
    setSelectedBond(b);
    setSelectedOperation(ope);
    if (detUrl) setDetVendeur(detUrl);
  };

  // update profondeur table in child component if match occurs
  const updateProfondeur = () => {
    if (selectedBond) {
      getBondMarket(selectedBond.id).then(({ data }) => {
        setMarketData(data);
      });
      getBondBidAsk(selectedBond.id).then(({ data }) => {
        setBondBidAsk(data);
      });
      getUserOrders(connectedUser.id).then(({ data }) => {
        setOrders(data);
      });
      getUserTransactions(connectedUser.id).then(({ data }) => {
        setTransactions(data);
      });
    }
  };

  // update order table in child component if modify or delete occurs
  const updateOders = () => {
    if (selectedBondforOPE) {
      getBondMarket(selectedBondforOPE.id).then(({ data }) => {
        setMarketData(data);
      });
      getBondBidAsk(selectedBondforOPE.id).then(({ data }) => {
        setBondBidAsk(data);
      });
      getUserOrders(connectedUser.id).then(({ data }) => {
        setOrders(data);
      });
    }
  };

  if (isLoading) return <Preloader />;

  return (
    <Layout>
      <Container>
        <div className='box1'>
          <div className='container11'>
            <OrderEntry
              selectedBond={selectedBond}
              selectedOpe={selectedOperation}
              detenteurVendeur={detVendeur} // alimenté uniquement pour les opérations de vente
              bondBidAsk={bondBidAsk}
              updateProfondeur={updateProfondeur}
            />
          </div>
          <div className='container12'>
            <div className='container121'>
              <InstrumentDetail
                selectedBond={selectedBond}
                bondBidAsk={bondBidAsk}
              />
            </div>
            <div className='container122'>
              <GraphData marketData={marketData} />
            </div>
          </div>
          <div className='container13'>
            <Activity
              orders={orders}
              transactions={transactions}
              updateOders={updateOders}
              getSelectedBond={setSelectedBondForOPE}
            />
          </div>
        </div>

        <div className='box2'>
          <div className='container21'>
            <Monitor
              bonds={bonds}
              bondOptions={bondOptions}
              getBond={getBondForOperation}
            />
          </div>
          <div className='container22'>
            <News />
          </div>
        </div>
      </Container>
    </Layout>
  );
};
